import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { allStations } from "./reducers/allStationsReducer";
import { rawData } from "./reducers/rawDataReducer";
import { sensors } from "./reducers/sensorsReducer";
import { sensor, sensorAnalysis, sensorUpdates } from "./reducers/sensorReducer";
import { weatherStations } from "./reducers/weatherStationsReducer";
import { weatherStation, weatherStationAnalysis } from "./reducers/weatherStationReducer";
import { weatherRegions } from "./reducers/weatherRegionsReducer";
import { weatherRegion } from "./reducers/weatherRegionReducer";

const rootReducer = combineReducers({
  allStations,
  rawData,
  sensors,
  sensor,
  sensorAnalysis,
  sensorUpdates,
  weatherStations,
  weatherStation,
  weatherStationAnalysis,
  weatherRegions,
  weatherRegion,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
